module.exports = __webpack_public_path__ + "static/media/home.1daafb1f.svg";